import { useEffect, useState } from "react";
import "../../../css/filters-map.css";
import "../../../css/index.css";
import "../../../css/registration.css";
import logo from "../../../assets/logo.png";
import NotificationDropdown from "../../common/NotificationDropdown";
import { apiClient } from "../../../utils/api";
import { useNotifications } from "../../../contexts/NotificationContext";

type MapSessionUser = {
  authenticated: boolean;
  welcome_name?: string;
  email?: string;
  role?: string;
};

const Header: React.FC = () => {
  const { state } = useNotifications();
  const [sessionUser, setSessionUser] = useState<MapSessionUser | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get<MapSessionUser>("/api/search/me/")
      .then((res) => {
        if (!cancelled) setSessionUser(res.data);
      })
      .catch(() => {
        if (!cancelled) setSessionUser({ authenticated: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Don't rely on reading `sessionid` from JS (often HttpOnly). Use runtime auth signal from API 401s.
  const isAuthorized = state.authChecked && !state.unauthorized;

  const handleLogout = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      await apiClient.post("/logout/");
      // Redirect to home page after logout
      window.location.href = "/home";
    } catch (error) {
      console.error("Logout error:", error);
      // Still redirect even if there's an error
      window.location.href = "/home";
    }
  };

  return (
    <header className="container">
      <nav
        className="navbar navbar-expand-lg fixed-top"
        id="navbar"
        aria-label=""
      >
        <div className="container">
          <div style={{ width: 132, height: "fit-content" }}>
            <a href="/home" className="flex items-center">
              <img
                className="h-8 w-auto"
                src={logo}
                alt="Logo"
              />
            </a>
          </div>
          <div className="d-flex align-items-center ms-auto">
            {sessionUser?.authenticated && sessionUser.welcome_name != null && (
              <div className="profile-info me-3">
                <span className="text-muted small">Welcome,</span>{" "}
                <span className="fw-semibold text-primary">
                  {sessionUser.welcome_name}
                </span>
              </div>
            )}
            <NotificationDropdown className="me-3" />

            <button
              className="navbar-toggler collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarsExample07"
              aria-controls="navbarsExample07"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <button
              type="button"
              className="btn btn-primary btn-header-mobile ms-3"
            >
              <i className="bi bi-search me-sm-1"></i>
              <span>Find Day Care</span>
            </button>
          </div>

          <div className="nav-mobile">
            <div
              className="navbar-collapse d-flex justify-content-center justify-content-lg-end collapse"
              id="navbarsExample07"
            >
              <ul className="nav nav-pills d-flex justify-content-center">
                <li className="nav-item">
                  <a href="#" className="nav-link" aria-current="page">
                    For Providers
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    For Parents
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    B2B Solutions
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-primary btn-header-desktop ms-2"
          >
            <i className="bi bi-search me-1"></i>
            <span>Find Day Care</span>
          </button>
          {isAuthorized && (
            <button
              type="button"
              className="btn btn-outline-primary ms-2 px-2"
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right me-1"></i>
              Logout
            </button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
